import ProxyClient from './clients/ProxyClient';

interface IRegNumberToken {
  token: string;
  page: string;
  param: string;
}

export const getRegNumberToken = async (regNumber: string) => {
  try {
    const { data } = await ProxyClient.get<IRegNumberToken>(`/osago/token`, { params: { regNumber } });

    return data;
  } catch (e) {
    throw new Error(e as string);
  }
};
